import { css } from 'styled-components';

export default css`
  .smooth-scroll-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
  }
  .smooth-scroll-list::-webkit-scrollbar {
    display: none;
  }
  .smooth-scroll-list-item {
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: 12px;
    }
  }
  .completeLook_carousel-wrapper {
    .slick-prev {
      left: 0;
    }
    .slick-next {
      right: 0;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      .slick-track {
        margin: 0;
      }
    }
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-bottom: ${(props) =>
        props.showCarousel ? props.theme.spacing.ELEM_SPACING.MED : '0px'};
    }
  }

  .outfit-image-wrapper {
    position: relative;
    cursor: pointer;
    @media ${(props) => props.theme.mediaQuery.large} {
      img {
        max-width: ${(props) => (props.bagOutfitProducts.length > 1 ? '100%' : '286px')};
      }
    }
  }
  .slick-slide > div {
    padding: 10px 0px;
  }
  .slick-slide img {
    box-shadow: none;
    border-radius: 6px;
    border: solid 1px ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  }
  .slick-slide:hover .shop-look-text {
    opacity: 1;
  }
  .slick-slide:hover .view-look-img {
    border: solid 1px ${(props) => props.theme.colorPalette.blue[800]};
  }
  .slick-slide {
    max-width: ${(props) => (props.showSmallImage ? `45%` : '70%')};
  }
  .slick-list {
    padding-left: 0px !important;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    .slick-slide > div {
      padding: 1px 12px;
    }
    .slick-list {
      margin: 0 38px;
    }
    .slick-slide {
      max-width: 50%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .slick-list {
      margin: 0px 10px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .slick-slide > div {
      padding: 16px 16px 0 0;
    }
    .slick-list {
      margin: 0;
    }
    .slick-slider {
      margin: 0;
    }
  }

  .slick-arrow {
    width: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    border: 1px solid ${(props) => props.theme.colorPalette.gray[500]};
    background-color: ${(props) => props.theme.colors.GHOST_OVERLAY};
    display: none !important;
  }

  .slick-arrow.slick-prev {
    left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }

  .slick-arrow.slick-next {
    right: 26px;
  }

  &:hover .slick-arrow,
  &:focus-within .slick-arrow {
    display: block !important;
  }

  .slick-arrow.slick-disabled {
    display: none !important;
  }
`;
